import React from 'react';
import classes from '../FitnessPreview.module.scss';
const CoachIcon = () => {
    return (
        <svg className={classes.coachIcon} width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.1605 11.37C12.0605 11.36 11.9405 11.36 11.8305 11.37C9.45055 11.29 7.56055 9.34 7.56055 6.94C7.56055 4.49 9.54055 2.5 12.0005 2.5C14.4505 2.5 16.4405 4.49 16.4405 6.94C16.4305 9.34 14.5405 11.29 12.1605 11.37Z" stroke="#062021" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M7.1607 15.06C4.7407 16.68 4.7407 19.32 7.1607 20.93C9.9107 22.77 14.4207 22.77 17.1707 20.93C19.5907 19.31 19.5907 16.67 17.1707 15.06C14.4307 13.23 9.9207 13.23 7.1607 15.06Z" stroke="#062021" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
}

export default CoachIcon;